import { IFormBuilderItemBase, IFormBuilderItemDataBase, TFormBuilderItem } from "./formBuilderItem";

type TFormBuilderDateType = "date";
export type TFormBuilderDateRole = "custom";

export interface IFormBuilderDateSettings {
  label: string;
  required: boolean;
}

export interface IFormBuilderDateData extends IFormBuilderItemDataBase {
  type: TFormBuilderDateType;
  role: TFormBuilderDateRole;
  settings: IFormBuilderDateSettings;
}

export interface IFormBuilderDate extends IFormBuilderItemBase {
  data: IFormBuilderDateData;
}

export type TFormBuilderDateSettings = IFormBuilderDate["data"]["settings"];

export function isFormBuilderDateItem(item: TFormBuilderItem): item is IFormBuilderDate {
  return item.data.type === "date";
}

export function isFormBuilderDateType(value: string): value is TFormBuilderDateType {
  return value === "date";
}

export function isFormBuilderDateRole(value: string): value is TFormBuilderDateRole {
  return value === "custom";
}

export function formBuilderGenerateDefaultCustomDate(): IFormBuilderDate {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "date",
      role: "custom",
      settings: {
        label: "Date", // TODO: Translation
        required: true,
      },
    },
  };
}
